import { Component, EventEmitter, forwardRef, Inject, Input, Output } from '@angular/core';

import { CompanyService } from '../companies/company.service';
import { SessionService } from '../sessions/session.service';

@Component({
  selector   : 'wor-vehicle-form-marine',
  template: require('./vehicle.form-marine.component.html')
})
export class VehicleFormMarineComponent {
  @Input() vehicle: any;
  @Input() company: any;
  @Input() customer: any;
  @Input() body_types: any[];
  @Input() body_types_limited: any[];
  @Input() transmission_types: any[];
  @Input() fuel_types: any[];
  @Input() hull_types: any[];
  @Input() hull_material_types: any[];
  @Input() regoLabel: string;
  @Input() isKiwi: boolean;
  @Input() plateDuplicate: boolean;
  @Input() vinDuplicate: boolean;

  @Output() onCheckPlate = new EventEmitter<void>();
  @Output() onDelete     = new EventEmitter<void>();
  @Output() onArchive    = new EventEmitter<void>();

  constructor(
    @Inject(forwardRef(() => CompanyService)) public companyService: CompanyService,
    @Inject(forwardRef(() => SessionService)) public sessionService: SessionService
  ) {}

  canUnarchiveVehicle(): boolean {
    return this.vehicle.id
      && this.vehicle.archived
      && !this.customer.archived;
  }
}
